import { render, staticRenderFns } from "./AddImageType.vue?vue&type=template&id=65dc2b3e&scoped=true&"
import script from "./AddImageType.vue?vue&type=script&lang=js&"
export * from "./AddImageType.vue?vue&type=script&lang=js&"
import style0 from "./AddImageType.vue?vue&type=style&index=0&id=65dc2b3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dc2b3e",
  null
  
)

export default component.exports